<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.add_notification") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Title Ar Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.notification_title_ar')"
            v-model.trim="data.titleAr"
            required
          />
          <!-- End:: Title Ar Input -->

          <!-- Start:: Title En Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.notification_title_en')"
            v-model.trim="data.titleEn"
            required
          />
          <!-- End:: Title En Input -->

          <!-- Start:: Body Ar Input -->
          <base-input
            col="6"
            rows="7"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.notification_body_ar')"
            v-model.trim="data.bodyAr"
            required
          />
          <!-- End:: Body Ar Input -->

          <!-- Start:: Body En Input -->
          <base-input
            col="6"
            rows="7"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.notification_body_en')"
            v-model.trim="data.bodyEn"
            required
          />
          <!-- End:: Body En Input -->

          <!-- Start:: Send To All Checkbox -->
          <div class="col-12 mb-3 gap-2">
            <v-checkbox
              v-model="data.sendToAll"
              :label="$t('PLACEHOLDERS.send_to_all')"
              color="primary"
              class="gap-2"
              @change="handleSendToAllChange"
            ></v-checkbox>
          </div>
          <!-- End:: Send To All Checkbox -->

          <!-- Start:: Recipients Select Input -->
          <base-select-input
            v-if="!data.sendToAll && data.users"
            col="12"
            :optionsList="data.users"
            :placeholder="$t('PLACEHOLDERS.notification_recipients')"
            v-model="data.selectedUsers"
            required
            multiple
          />
          <!-- End:: Recipients Select Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.send')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateNotification",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        users: [],
        selectedUsers: [],
        titleAr: null,
        titleEn: null,
        bodyAr: null,
        bodyEn: null,
        sendToAll: false,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Get Active Users
    async getActiveUsers() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "users?limit=0&page=0",
          params: {
            is_active: 1,
          },
        });
        this.data.users = res.data.data.map((user) => ({
          id: user.id,
          name: user.name || user.mobile || `User ${user.id}`,
        }));
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },
    // End:: Get Active Users

    // Start:: Handle Send To All Change
    handleSendToAllChange() {
      if (this.data.sendToAll) {
        this.data.selectedUsers = [];
      }
    },
    // End:: Handle Send To All Change

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.titleAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.notification_title_ar"));
        return;
      } else if (!this.data.titleEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.notification_title_en"));
        return;
      } else if (!this.data.bodyAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.notification_body_ar"));
        return;
      } else if (!this.data.bodyEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.notification_body_en"));
        return;
      } else if (!this.data.sendToAll && this.data.selectedUsers.length === 0) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.notification_recipients"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Start:: Append Request Data
      REQUEST_DATA.append("title_ar", this.data.titleAr);
      REQUEST_DATA.append("title_en", this.data.titleEn);
      REQUEST_DATA.append("body_ar", this.data.bodyAr);
      REQUEST_DATA.append("body_en", this.data.bodyEn);

      if (this.data.sendToAll) {
        REQUEST_DATA.append("to_all", 1);
      } else {
        this.data.selectedUsers.forEach((user) => {
          REQUEST_DATA.append("users[]", user.id);
        });
        REQUEST_DATA.append("to_all", 0);
      }
      // End:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: "notifications/store",
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.sentSuccessfully"));
        this.$router.push({ path: "/all-notifications/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response?.data?.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    // Start:: Fire Methods
    this.getActiveUsers();
    // End:: Fire Methods
  },
};
</script>
<style>
.v-input__slot {
  gap: 3px;
}
</style>
